<script setup>
import { faAt, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useI18n } from 'petite-vue-i18n'

const { t } = useI18n()
</script>

<template>
  <footer class="footer pt-2 pb-2 has-background-grey">
    <div class="container has-text-centered">
      <a class="icon-text is-underlined has-text-white" :href="t('common.url.support_email.href')">
        <span class="icon">
          <FontAwesomeIcon :icon="faAt" />
        </span>
        <span>{{ t('common.url.support_email.label') }}</span>
      </a>
      <span class="pl-4 pr-4 is-hidden-touch" />
      <br class="is-hidden-tablet">
      <span class="is-hidden-mobile p-4"><!-- spacer --></span>
      <a class="icon-text is-underlined has-text-white" :href="t('common.url.support_phone.href')">
        <span class="icon">
          <FontAwesomeIcon :icon="faPhone" />
        </span>
        <span>{{ t('common.url.support_phone.label') }}</span>
      </a>
    </div>
  </footer>
</template>
